import React, { FC } from "react";
import st from "./chartheader.module.scss";

interface ChartHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

const ChartHeader: FC<ChartHeaderProps> = ({ children, ...rest}) =>
    <span className={st.title} {...rest}>{children}</span>

export default ChartHeader;
